import React from 'react';
import BaseTextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

const TextField = (props) => <BaseTextField {...props} />;

TextField.defaultProps = {
  variant: 'outlined',
};

TextField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.any,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  autoFocus: PropTypes.bool,
  autoComplete: PropTypes.string,
  helperText: PropTypes.node,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
};

export default (props) => <TextField {...props}/>;
